import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import { QRCodeSVG } from "qrcode.react";

type Props = {
    open: boolean;
    onClose: () => void;
    projectId: string;
};

const MobileUploadDialog: React.FC<Props> = ({ open, onClose, projectId }) => {
    const uploadUrl = `${window.location.origin}/mobile-upload/${encodeURIComponent(projectId)}`;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            PaperProps={{ sx: { borderRadius: 3, backgroundImage: "none" } }}
        >
            <DialogTitle sx={{ fontWeight: 700, pb: 1 }}>Upload from mobile</DialogTitle>
            <DialogContent>
                <Typography sx={{ color: "text.secondary", lineHeight: 1.55, mb: 3 }}>
                    Scan this code with your phone, sign in, and choose an audio or video file.
                </Typography>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        width: "fit-content",
                        mx: "auto",
                        p: 2,
                        border: "1px solid",
                        borderColor: "divider",
                        borderRadius: 2,
                        backgroundColor: "common.white",
                    }}
                >
                    <QRCodeSVG value={uploadUrl} size={220} />
                </Box>
                <Typography sx={{ color: "text.secondary", fontSize: 12, mt: 2, textAlign: "center" }}>
                    Maximum file size: 250 MB
                </Typography>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 3 }}>
                <Button onClick={onClose} variant="contained" color="primary" disableElevation sx={{ minWidth: 96 }}>
                    Done
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default MobileUploadDialog;
